
import React, { useCallback } from 'react';
import { NodeViewWrapper } from '@tiptap/react';


function isSameOrigin(url) {
  if (url) {
    const currentFont = window.location;
    const newUrl = new URL(url);
    return newUrl.hostname === 'localhost' || newUrl.hostname.includes('acara.io') ||currentFont.origin === newUrl.origin;
  }
}


function CustomIframeComponent(props) {

  const onResize = useCallback((mouseDownEvent) => {

      mouseDownEvent.preventDefault();
      mouseDownEvent.stopPropagation();
  
      const parent = (mouseDownEvent.target).closest('.custom-iframe');
      const iframe = parent?.querySelector('iframe') ?? null;
  
      if(iframe === null) return;
  
      const startSize = { x: iframe.clientWidth, y: iframe.clientHeight };
      const startPosition = { x: mouseDownEvent.pageX, y: mouseDownEvent.pageY };
  
      const componentProps = props;
  
      const onMouseMove = (mouseMoveEvent) => {
  
        componentProps.updateAttributes({
          width: startSize.x - startPosition.x + mouseMoveEvent.pageX >= 0 ? startSize.x - startPosition.x + mouseMoveEvent.pageX : 0, 
          height: startSize.y - startPosition.y + mouseMoveEvent.pageY >= 0 ? startSize.y - startPosition.y + mouseMoveEvent.pageY : 0
        })
      }
      const onMouseUp = () => {
        document.querySelector('iframe').contentDocument.body.removeEventListener("mousemove", onMouseMove);
      }
  
      document.querySelector('iframe').contentDocument.body.addEventListener("mousemove", onMouseMove);
      document.querySelector('iframe').contentDocument.body.addEventListener("mouseup", onMouseUp, { once: true });

  }, []);

  const dragHandle =  (
    <div className='resize-trigger' onMouseDown={onResize} style={{fontSize: '2rem', cursor: 'pointer', position: 'absolute', bottom: 0, right: '0.5rem', zIndex: 3, color: '#FFF', cursor: 'nwse-resize', userSelect: 'none', textShadow: 'rgb(72, 53, 198) 0px 0px 10px'}}>
      ◉
    </div>
  );

  const thisStyles = props.node.attrs.style;

  const isSame = isSameOrigin(props.node.attrs.src);

  return (
      <NodeViewWrapper className={props.editor.isActive('iframe') ? 'custom-iframe active' : 'custom-iframe'} style={{width: 'fit-content', width: '100%', height: '100%', ...thisStyles}}
      >
          <div 
            data-drag-handle
            draggable={true}
            contentEditable={false}
            style={{
              position: 'relative',
              width: 'fit-content',
              display: 'flex',
              width: props.node.attrs.width === '100%' ? '100%' : props.node.attrs.width+'px',
              height: props.node.attrs.height === '100%' ? 600 : props.node.attrs.height+'px',
              maxWidth: '100%'
            }}
          >
            { 
              isSame ? (
                <div style={{
                  border: '1px solid #999',
                  background: 'rgba(0, 0, 0, 0.2)',
                  textAlign: 'center',
                  padding: '2rem',
                  display: 'grid',
                  alignItems: 'center',
                  width: '100%'
                }}>Embedding of this origin content is not allowed.</div>
              ) : (
                <iframe 
                  src={props.node.attrs.src}
                  contentEditable={false}
                  style={{userSelect: 'none', width: props.node.attrs.width, height: props.node.attrs.height === '100%' ? 600 : props.node.attrs.height}}
                  allowFullScreen
                  loading={'lazy'}
                  referrerPolicy={'no-referrer'}
                />
              )
            }

            {props.editor.options.editable ? dragHandle : null }
          </div>
      </NodeViewWrapper>
  )
}


export default CustomIframeComponent